const accessibleTabsViewTemplate = `
<div id="accessibleTabs">
    <ul class="nav nav-tabs hidden-xs accessible-tabs-list" id="{{ tabNavigationId }}">
        <li ui-sref-active="active" ng-repeat="tab in tabs | filter:{condition:true}" id="{{ tab.id }}" role="presentation">
            <a ng-attr-tabindex="{{ $first ? '0' : ''  }}"
                ui-sref="{{tab.uiSref}}"
                aria-selected="{{ tab.uiSref | isState }}"
                ng-click="handleAccessibleTabClick()"
            >
                {{ tab.text }}
            </a>
        </li>
    </ul>
    <div class="tab-content hidden-xs" id="{{ tabContentId }}">
        <div class="tab-pane active">
            <ui-view></ui-view>
        </div><!--//.tab-pane//-->
    </div><!--//tab-content//-->
</div>
`;
export default accessibleTabsViewTemplate;